import { render, staticRenderFns } from "./bellCurveResult.vue?vue&type=template&id=03ed3c6c"
import script from "./bellCurveResult.vue?vue&type=script&lang=js"
export * from "./bellCurveResult.vue?vue&type=script&lang=js"
import style0 from "./bellCurveResult.vue?vue&type=style&index=0&id=03ed3c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports